module.exports = __webpack_public_path__ + "static/img/bg-image.de2a191.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/guose/bg-image.png
// module id = SXl2
// module chunks = 1